export default {
    features: {
        GENDER_FIELDS: true,
        GRADE_DROPDOWN: true,
        ORIGINAL_OVERLAY: true,
        OLYMPICS_OVERLAY: false,
        SOUNDS: true
    }
}